export default __webpack_public_path__ + "static/media/drop.e7511a52.svg";